import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inlineSize", "blockSize"];
import { View } from 'foundations-components/components/View';
import SkeletonView from './SkeletonView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonText = _ref => {
  let {
      inlineSize = '100%',
      blockSize = 'auto'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: inlineSize,
    blockSize: blockSize,
    position: "relative",
    maxBlockSize: "24px",
    children: [/*#__PURE__*/_jsx(SkeletonView, Object.assign({
      marginBlock: "auto"
    }, rest, {
      inlineSize: "100%",
      blockSize: "0.75em",
      position: "absolute",
      inset: "0"
    })), "\xA0"]
  });
};
SkeletonText.displayName = 'SkeletonText';
export default SkeletonText;